import { render, staticRenderFns } from "./mx-global-tips.vue?vue&type=template&id=7a6ea66d&scoped=true&"
import script from "./mx-global-tips.vue?vue&type=script&lang=js&"
export * from "./mx-global-tips.vue?vue&type=script&lang=js&"
import style0 from "./mx-global-tips.vue?vue&type=style&index=0&id=7a6ea66d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6ea66d",
  null
  
)

export default component.exports